import { createSlice } from "@reduxjs/toolkit";
import { resetdeckblatt } from "../resetParameters";

const initialState = {
  Project: {
    title: "",
    subtitle: "",
    text: "",
  },
  PreparedBy: {
    company: "",
    username: "",
    createdAt: "",
  },
  CompanyLogo: {
    LogoBase64Url: "",
  },
};

const deckblattSlice = createSlice({
  name: "deckblatt",
  initialState,
  reducers: {
    setDeckblattState(state, action) {
      state.Project = action.payload.Project;
      state.PreparedBy = action.payload.PreparedBy;
      state.CompanyLogo = action.payload.CompanyLogo;
    },
    setProjectTitle(state, action) {
      state.Project.title = action.payload;
    },
    setProjectSubtitle(state, action) {
      state.Project.subtitle = action.payload;
    },
    setProjectText(state, action) {
      state.Project.text = action.payload;
    },

    setPreparedByCompany(state, action) {
      state.PreparedBy.company = action.payload;
    },
    setPreparedByUsername(state, action) {
      state.PreparedBy.username = action.payload;
    },
    setCreatedAt(state, action) {
      state.PreparedBy.createdAt = action.payload;
    },
    setLogoImageBase64Url(state, action) {
      state.CompanyLogo = { LogoBase64Url: action.payload };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetdeckblatt, (state, action) => {
      return initialState;
    });
  },
});

export const {
  setDeckblattState,
  setProjectTitle,
  setCreatedAt,
  setProjectSubtitle,
  setProjectText,
  setPreparedByCompany,
  setPreparedByUsername,
  setLogoImageBase64Url,
} = deckblattSlice.actions;

export default deckblattSlice.reducer;

export const selectProject = (state) => state.deckblatt.Project;
export const selectPreparedBy = (state) => state.deckblatt.PreparedBy;

export const selectProjectTitle = (state) => state.deckblatt.Project.title;
export const selectProjectSubtitle = (state) => state.deckblatt.Project.subtitle;
export const selectProjectText = (state) => state.deckblatt.Project.text;

export const selectPreparedByCompany = (state) => state.deckblatt.PreparedBy.company;
export const selectPreparedByUsername = (state) => state.deckblatt.PreparedBy.username;
export const selectPreparedByCreatedAt = (state) => state.deckblatt.PreparedBy.createdAt;
export const selectLogoImageBase64Url = (state) =>
  state.deckblatt?.CompanyLogo?.LogoBase64Url || "";
